import {useNavigate} from 'react-router-dom'; // or your routing library
import {Notification} from '../../../../services/hookService/getNotificationsList/type';
import {timeAgoPersian} from '../../../../utilities/helper/GetPersianDateTime';
import {
  DEFAULT_THEME,
  getThemeByColor,
  IconCodeToIconString,
} from '../../constants/notificaitonCardColors';

interface Props {
  notification: Notification;
  onClick?: () => void;
}

const NotificationCard: React.FC<Props> = ({notification, onClick}) => {
  const {
    title,
    description,
    button_link,
    button_text,
    sponsor,
    created_at,
    color_icon_code,
  } = notification;

  const navigate = useNavigate();
  const theme = getThemeByColor(color_icon_code?.[0]) || DEFAULT_THEME;

  // future proof. they did not want this but i added it anyway.
  const isExternalLink = (url: string) => {
    return url.startsWith('http://') || url.startsWith('https://');
  };

  const handleButtonClick = () => {
    if (!button_link) return;

    if (isExternalLink(button_link)) {
      window.open(button_link, '_blank', 'noopener,noreferrer');
    } else {
      navigate(button_link);
    }
  };

  return (
    <div className="flex flex-col">
      <div
        className={`p-3 flex flex-col gap-[1rem] rounded-lg shadow-sm ${theme.background}`}
        onClick={onClick}
      >
        {/* Main Title */}
        <div className={`flex items-center gap-2 ${theme.text}`}>
          <i
            className={`text-xl ${IconCodeToIconString(color_icon_code?.[1])}`}
          />
          <span className="text-sm font-medium">{title}</span>
        </div>

        {/* Description */}
        <div className="text-sm text-gray-600">{description}</div>

        {/* Action Button */}
        <div className="flex items-center justify-between">
          <span className="text-sm font-normal text-gray-600">
            {timeAgoPersian(created_at)}
          </span>
          {button_link && button_text && (
            <button
              onClick={handleButtonClick}
              className={`inline-flex items-center no-underline justify-center rounded-lg px-[1rem] py-2 text-sm font-normal text-white
              ${theme.button}
            `}
            >
              {button_text}
            </button>
          )}
        </div>
      </div>

      {/* Sponsor Footer */}
      {sponsor && (
        <div
          className={`flex items-center gap-2 border-t-[3px] px-[1rem] py-2 rounded-b-lg border-white ${theme.background}`}
          onClick={() =>
            window.open(sponsor.link, '_blank', 'noopener,noreferrer')
          }
        >
          <img
            src={sponsor.icon}
            alt={sponsor.text}
            className="object-cover w-6 h-6 rounded-md"
          />
          <span className="text-xs text-gray-500">{sponsor.text}</span>
        </div>
      )}
    </div>
  );
};

export default NotificationCard;
